import { TransactionFlag } from '@shared/transactions-types';

import type { TransactionPredicate } from './types';
import { hasField } from './hasField';
import { hasFlag } from './hasFlag';

export const hasEditableField =
    (propertyPath: string): TransactionPredicate =>
    (transaction) =>
        hasField(propertyPath)(transaction) || !hasFlag(TransactionFlag.IS_ARCHIVED)(transaction);
